import type { NodeViewRenderers } from './../../ricos-types';
import { Node_Type } from './../../ricos-types';

import Divider from './divider';

export const nodeViewRenderers: NodeViewRenderers = {
  [Node_Type.DIVIDER]: Divider,
};
